export const livingPlaces: string[] = [
  'Altstätten',
  'Buchs (SG)',
  'Ebnat-Kappel',
  'Eschenbach (SG)',
  'Flawil',
  'Flums',
  'Gaiserwald',
  'Gams',
  'Goldach',
  'Gommiswald',
  'Gossau (SG)',
  'Grabs',
  'Jonschwil',
  'Kirchberg (SG)',
  'Lichtensteig',
  'Lütisburg',
  'Mels',
  'Mörschwil',
  'Mosnang',
  'Neckertal',
  'Nesslau',
  'Niederhelfenschwil',
  'Oberuzwil',
  'Quarten',
  'Rapperswil-Jona',
  'Rorschach',
  'Rorschacherberg',
  'Sargans',
  'Schmerikon',
  'Sennwald',
  'Sevelen',
  'St. Gallen',
  'Steinach',
  'Tübach',
  'Uznach',
  'Uzwil',
  'Vilters-Wangs',
  'Walenstadt',
  'Wartau',
  'Wattwil',
  'Wil',
  'Wittenbach',
  'Zuzwil',
];
